import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { StrandedSessionsBoResponse } from '@utils/types/back-office/stranded-sessions';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetAllStrandedSessionIds = () => {
  const { t } = useTranslation();

  const fetchAllSessionIds = async () => {
    // Page through results in chunks — backend caps limit at 1000 per call.
    const PAGE_SIZE = 1000;
    const sessionIds: string[] = [];
    let offset = 0;
    let total = 0;

    for (;;) {
      const { strandedSessions: pageUrl } = GET_URL_NEW({
        offset,
        limit: PAGE_SIZE
      });

      const { data } = await Axios.get<StrandedSessionsBoResponse>(pageUrl);
      total = data.total_results || 0;

      sessionIds.push(...data.result.map(item => item.session_id));

      offset += data.result.length;
      if (data.result.length < PAGE_SIZE || offset >= total) break;
    }

    return { sessionIds, total };
  };

  return useQuery<
    { sessionIds: string[]; total: number },
    AxiosError<BaseError>
  >(['allStrandedSessionIds'], fetchAllSessionIds, {
    useErrorBoundary: false,
    staleTime: 30000, // Consider data fresh for 30 seconds
    onError: (error: AxiosError<BaseError>) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const d = error.response?.data as any;
      const msg =
        d?.error_description ||
        d?.detail ||
        d?.error ||
        d?.message ||
        t('an-error-occurred');
      toast.error(String(msg));
    }
  });
};
